import React from 'react'
import { createRoot } from 'react-dom/client'
import HelloWorld from './HelloWorld'
import ContactForm from './ContactForm'

import './navTabbable'
import './navDisclosure'

const COMPONENTS = {
  HelloWorld,
  ContactForm
}

function renderComponentInElement (el) {
  const Component = COMPONENTS[el.dataset.component]
  if (!Component) return
  // get props from elements data attribute, like the post_id
  const props = Object.assign({}, el.dataset)
  const root = createRoot(el) // createRoot(container!) if you use TypeScript
  root.render(<Component {...props} />, el)
}

document
  .querySelectorAll('.__react-component')
  .forEach(renderComponentInElement)
